import { render, staticRenderFns } from "./scoreQuery.vue?vue&type=template&id=778d15de&scoped=true&"
import script from "./scoreQuery.vue?vue&type=script&lang=js&"
export * from "./scoreQuery.vue?vue&type=script&lang=js&"
import style0 from "./scoreQuery.vue?vue&type=style&index=0&id=778d15de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d15de",
  null
  
)

export default component.exports